<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="hrissecondary"
        class="white--text px-10"
        block
        v-on="on"
      >
        Create
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Tax Relief"
      text="Create tax relief"
      class="mb-0"
      :loading="loading"
    > 
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="code"
                v-validate="'required'" 
                label="Code"
                :error-messages="errors.collect('code')"
                data-vv-name="code"    
                data-vv-as="code" 
                outlined
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="name"
                v-validate="'required'" 
                label="Name"
                :error-messages="errors.collect('name')"
                data-vv-name="name"    
                data-vv-as="name" 
                outlined
              />
            </v-col>

            <v-col cols="12">
              <tiptap-vuetify
                v-model="description"
                class="full-width text-editor-toolbar-height pb-1"
                placeholder="Description"
                :extensions="extensions"
              />
            </v-col>
            
            <v-col cols="12">
              <v-text-field
                v-model="amount"
                v-money="money"
                label="Amount"
                prefix="RM"
                outlined
                @keydown.native="['-', 'Subtract'].includes($event.key) && $event.preventDefault()"
                @paste.native="$event.clipboardData.getData('text').includes('-') && $event.preventDefault()"
              />
            </v-col>

            <v-col cols="12">
              <span>Compulsory Deduction? </span>
              <v-radio-group
                v-model="isCompulsoryDeduction"
                class="mt-0"
                row
              >
                <v-radio
                  label="Yes"
                  :value="true"
                /> 
                <v-radio
                  label="No"
                  :value="false"
                />
              </v-radio-group>
            </v-col>

            <v-col cols="12">
              <v-autocomplete
                v-model="taxReliefParent"
                label="Tax Relief Parent"
                :items="taxReliefParents"
                item-text="name"
                item-value="id"
                outlined
              />
            </v-col>

            <v-col cols="12">
              <span>Relief or Rebate? </span>
              <v-radio-group
                v-model="isRelief"
                class="mt-0"
                row 
              >
                <v-radio
                  label="Relief"
                  value="relief"
                /> 
                <v-radio
                  label="Rebate"
                  value="rebate"
                />
              </v-radio-group>
            </v-col>
          </v-row>
        </v-container>
      </form> 
      
      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"           
          @click="submitForm"
        >
          Save
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import { VMoney } from 'v-money'
  import { TiptapVuetify, Heading, Bold, Italic, Underline, BulletList, OrderedList, ListItem, Link, HardBreak } from 'tiptap-vuetify'
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    directives: { money: VMoney },
    components: {
      TiptapVuetify,
    },
    props: {
      year: {
        type: Number,
        default: null,
      },
    },
    data () {
      return {
        progressing: false,
        dialog: null,
        loading: false,
        name: null,
        code: null,
        description: null,
        extensions: [
          Link,
          Underline,
          Italic,
          ListItem,
          BulletList,
          OrderedList,
          [Heading, {
            options: {
              levels: [1, 2, 3],
            },
          }],
          Bold,
          HardBreak,
        ],
        isCompulsoryDeduction: false,
        isRelief: 'relief',
        taxReliefParents: [],
        taxReliefParent: null,
        amount: null,
        money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false, /* doesn't work with directive */
        },
        yearFilter: parseInt(this.$moment().format('YYYY')),
      }
    },

    watch: {
      dialog (value) {
        if (!value) return this.$resetData()
        this.loading = true

        this.$api.taxReliefs().list({ year: this.yearFilter })
          .then(response => {
            this.taxReliefParents = _.orderBy(response.data, ['code'], ['asc'])

            this.loading = false
          })
      },
    },
    methods: { 
      prepareFormData () {
        return {
          code: this.code,
          name: this.name,
          description: this.description,
          is_compulsory_deduction: this.isCompulsoryDeduction,
          type: this.isRelief,
          parent_id: this.taxReliefParent,
          amount: this.amount.toString().replaceAll(',', ''),
          year: this.year,
        }
      },   
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.setProgressing(true)
    
            this.$api.taxReliefs().create(this.prepareFormData())
              .then((response) => {
                if (response.status === 200 || response.status === 201) {
                  this.$emit('created')                
                  this.$snack({ message: response.data.status })

                  this.setProgressing(false)
                  this.dialog = false       
                }
              })
              .catch((err) => {
                if (err.response.status === 422) {    
                  this.$snack({ 
                    color: 'error',
                    message: err.response.data.status, 
                  })
                }         
                
                this.setProgressing(false)
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
    },
  }
</script>

<style scoped>
.text-editor-toolbar-height>>> .v-toolbar__content{
  height: unset !important;
  min-height: 42px;
}
.text-editor-toolbar-height>>>.v-sheet.v-sheet--tile.theme--light.v-toolbar.v-toolbar--dense.v-toolbar--flat.grey.lighten-4{
  min-height:unset !important;
}
.full-width{
  width: 100%;
}
</style>

<style scoped>
.fix-date-picker-outline-overlap >>> label{
  background: white;
  padding-right:10px;
}
</style>
